export default [
  { value: 'CLIENT', label: 'Client' },
  { value: 'CONTRACTOR', label: 'Contractor' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'QUALITY_CONTROL', label: 'Quality Control' },
  { value: 'REVIEWER', label: 'Reviewer' },
];
